export default __webpack_public_path__ + "/dist/images/2592193.2951fa0d434f73cd3aaf77f04f993645.png";